// Rebuy bundle builder: serve product card images at their rendered size.
// Rebuy hardcodes 400x400 Shopify URLs, so this adds a srcset off the same file and rebuilds it whenever Rebuy swaps the src (hover, variant change).
(function () {
  const IMG_SEL = '.rebuy-bundle-builder__step-body .rebuy-product-image img';
  const SIZE_RE = /_400x400(?=\.[a-z]+(\?|$))/i;
  const WIDTHS = [400, 600, 800, 1000, 1200, 1600];

  const tracked = new WeakSet();
  const resizeObserver = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      setSizes(entry.target);
    });
  });

  function sizedUrl(src, width) {
    const url = new URL(src.replace(SIZE_RE, ''), location.href);
    url.searchParams.set('width', width);
    return url.href;
  }

  // object-fit: cover, so an image narrower than the box ratio fills its height and overflows its width
  function setSizes(img) {
    const box = img.getBoundingClientRect();
    const ratio = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 1;
    img.sizes = Math.ceil(Math.max(box.width, box.height * ratio)) + 'px';
  }

  function upgrade(img) {
    const src = img.getAttribute('src') || '';

    if (!SIZE_RE.test(src)) {
      img.removeAttribute('srcset');
      return;
    }

    // sizes first, or the browser picks from srcset against the default 100vw
    setSizes(img);
    img.srcset = WIDTHS.map(function (width) {
      return sizedUrl(src, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function handle(img) {
    if (!tracked.has(img)) {
      tracked.add(img);
      img.addEventListener('load', function () {
        setSizes(img);
      });
      resizeObserver.observe(img);
    }

    upgrade(img);
  }

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'attributes') {
        if (record.target.matches(IMG_SEL)) handle(record.target);
        return;
      }

      record.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches(IMG_SEL)) handle(node);
        node.querySelectorAll(IMG_SEL).forEach(handle);
      });
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });

  document.querySelectorAll(IMG_SEL).forEach(handle);
})();
